import React from "react";
import "./bloghero.scss";
import backpic from "../../../assets/images/blogbackpic.png";
import heropic from "../../../assets/images/heropic.png";
import blog1 from "../../../assets/images/blog1.png";
import img3 from "../../../assets/images/blog2img.png";
import blog3img from "../../../assets/images/blog3img.png";
import blog3img2 from "../../../assets/images/blog3img2.png";
const Bloghero = () => {
  return (
    <div>
      <div className="blogbackpic">
        <img src={backpic} alt="" />
      </div>
      <div className="bloghero-clr">
        <div className="bloghero">
          {/* <div className="heroback">
          <img src={heroback} alt="" />
        </div> */}
          <div className="herohead">
            <h1>Blogs</h1>
            <img src={heropic} alt="" />
          </div>
          <div className="herotext">
            <div className="authname">
              <p>
                By <span>John Doe</span> l Aug 23, 2021{" "}
              </p>
            </div>
            <div className="authcont">
              <h2>Lorem ipsum dolor sit amet consectetur adipiscing elit</h2>
              <p>
                Vestibulum hendrerit, est vitae tincidunt scelerisque, tellus
                nisl facilisis nisl, non pharetra ante odio vitae tellus. Donec
                nibh elit, vulputate et tincidunt efficitur, luctus placerat
                ante. Aenean eget risus quis erat aliquet scelerisque. Morbi
                orci lacus, ultricies eu est vitae, tristique luctus lectus.
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <p>
                In diam nulla, suscipit nec purus vel, commodo aliquet eros.
                Nullam eu vehicula diam. Cras ac scelerisque dolor, quis
                accumsan lacus. Orci varius natoque penatibus et magnis dis
                parturient montes, nascetur ridiculus mus. Vivamus interdum ex
                vitae justo semper, in cursus ex consectetur. Morbi ex leo,
                varius ac eros ut, luctus finibus turpis. Etiam in varius ex.
                Donec orci ligula, aliquet non lectus sit amet, rutrum cursus
                urna. Proin nisi ipsum, tristique eget lorem ut, faucibus
                laoreet sapien.
              </p>
            </div>
          </div>

          {/* <div className="midback">
          <img src={midbackpic} alt="" />
        </div> */}
          <div className="blogmid">
            <div className="blogmidcont">
              <div className="author">
                <p>
                  By <span>John Doe</span> l Aug 23, 2021
                </p>
              </div>
              <h2>
                Ut suscipit faucibus purus non fermentum neque elementum quis
                suspendisse condimentum vestibulum lacinia
              </h2>
              <p>
                Nulla nec lectus ut quam tempor gravida et non mi. Pellentesque
                rutrum dolor lectus, ut scelerisque nisl dictum ac. Sed
                fringilla suscipit rutrum. Vivamus facilisis hendrerit feugiat.
                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
                posuere cubilia curae; Morbi ut diam elementum, aliquam augue
                sit amet, lacinia massa.
              </p>
              <div className="blog_card">
                <div className="card-img">
                  <img src={blog1} alt="" />
                </div>
                <div className="card-content">
                  <div className="author_name">
                    <p>
                      {" "}
                      By <span>John Doe</span> l Aug 23, 2021{" "}
                    </p>
                  </div>

                  <h2>
                    Vestibulum ante ipsum primis in faucibus orci luctus et
                    ultrices posuere cubilia curae
                  </h2>
                  <p>
                    Praesent tempor gravida magna, id accumsan risus gravida et.
                    Aliquam id volutpat nulla, vitae semper massa. Ut et
                    eleifend lectus, ac porttitor sapien. Praesent ac nisi eu
                    arcu laoreet interdum sit amet id massa. Maecenas malesuada
                    enim et maximus cursus. Donec eu diam at lectus consequat
                    hendrerit. Duis ut ornare eros. Etiam eleifend, erat eget
                    sollicitudin laoreet, libero magna convallis nulla, at
                    semper ligula nibh eget lacus. Pellentesque accumsan lorem
                    neque, in luctus urna tempor vitae.{" "}
                  </p>
                </div>
              </div>

              <p>
                In diam nulla, suscipit nec purus vel, commodo aliquet eros.
                Nullam eu vehicula diam. Cras ac scelerisque dolor, quis
                accumsan lacus. Orci varius natoque penatibus et magnis dis
                parturient montes, nascetur ridiculus mus. Vivamus interdum ex
                vitae justo semper, in cursus ex consectetur. Morbi ex leo,
                varius ac eros ut, luctus finibus turpis. Etiam in varius ex.
                Donec orci ligula, aliquet non lectus sit amet, rutrum cursus
                urna. Proin nisi ipsum, tristique eget lorem ut, faucibus
                laoreet sapien.
              </p>
              <p>
                Praesent tempor gravida magna, id accumsan risus gravida et.
                Aliquam id volutpat nulla, vitae semper massa. Ut et eleifend
                lectus, ac porttitor sapien. Praesent ac nisi eu arcu laoreet
                interdum sit amet id massa. Maecenas malesuada enim et maximus
                cursus. Donec eu diam at lectus consequat hendrerit. Duis ut
                ornare eros.
              </p>
              <p>
                Nulla nec lectus ut quam tempor gravida et non mi. Pellentesque
                rutrum dolor lectus, ut scelerisque nisl dictum ac. Sed
                fringilla suscipit rutrum. Vivamus facilisis hendrerit feugiat.
                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
                posuere cubilia curae; Morbi ut diam elementum, aliquam augue
                sit amet, lacinia massa. Interdum et malesuada fames ac ante
                ipsum primis in faucibus. Pellentesque habitant morbi tristique
                senectus et netus et malesuada fames ac turpis egestas. Proin
                elementum facilisis ex ac semper. Aliquam dapibus magna eget
                tortor volutpat, in sodales neque lobortis. Phasellus odio
                magna, tincidunt vel nibh sit amet, gravida malesuada dui.
                Quisque malesuada rutrum feugiat.
              </p>
            </div>
          </div>
          {/* <div className="midback2">
          <img src={heroback} alt="" />
        </div> */}

          <div className="blog2">
            <div className="blog_card">
              <div className="card-img">
                <img src={img3} alt="" />
              </div>
              <div className="card-content">
                <div className="author_name">
                  <p>
                    {" "}
                    By <span>John Doe</span> l Aug 23, 2021{" "}
                  </p>
                </div>
                <h2>
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae
                </h2>
                <p>
                  Praesent tempor gravida magna, id accumsan risus gravida et.
                  Aliquam id volutpat nulla, vitae semper massa. Ut et eleifend
                  lectus, ac porttitor sapien. Praesent ac nisi eu arcu laoreet
                  interdum sit amet id massa. Maecenas malesuada enim et maximus
                  cursus. Donec eu diam at lectus consequat hendrerit. Duis ut
                  ornare eros. Etiam eleifend, erat eget sollicitudin laoreet,
                  libero magna convallis nulla, at semper ligula nibh eget
                  lacus. Pellentesque accumsan lorem neque, in luctus urna
                  tempor vitae.{" "}
                </p>
              </div>
            </div>

            <div className="auth2">
              <p>
                By <span>John Doe </span> l Aug 23, 2021
              </p>
            </div>
            <h2>
              Praesent tempor gravida magna id accumsan risus gravida et aliquam
              id volutpat nulla vitae semper
            </h2>
            <p>
              In diam nulla, suscipit nec purus vel, commodo aliquet eros.
              Nullam eu vehicula diam. Cras ac scelerisque dolor, quis accumsan
              lacus. Orci varius natoque penatibus et magnis dis parturient
              montes, nascetur ridiculus mus. Vivamus interdum ex vitae justo
              semper, in cursus ex consectetur. Morbi ex leo, varius ac eros ut,
              luctus finibus turpis. Etiam in varius ex. Donec orci ligula,
              aliquet non lectus sit amet, rutrum cursus urna.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
              orci odio, convallis non lectus eu, fringilla mattis ex. Interdum
              et malesuada fames ac ante ipsum primis in faucibus. Phasellus ex
              sapien, viverra eu luctus non, suscipit sed lorem. Nulla facilisi.
              Cras venenatis commodo nunc non vehicula. Ut suscipit faucibus
              purus, non fermentum neque elementum quis. Suspendisse condimentum
              vestibulum lacinia. Vestibulum hendrerit, est vitae tincidunt
              scelerisque, tellus nisl facilisis nisl, non pharetra ante odio
              vitae tellus. Donec nibh elit, vulputate et tincidunt efficitur,
              luctus placerat ante. Aenean eget risus quis erat aliquet
              scelerisque. Morbi orci lacus, ultricies eu est vitae, tristique
              luctus lectus. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit. Proin vitae odio ante. Quisque et leo et libero egestas
              pellentesque. Aliquam a odio ac massa cursus venenatis.
            </p>
            <p>
              Mauris eget metus enim. Nam massa odio, euismod faucibus
              vestibulum at, dignissim a est. Ut malesuada est dolor, eu
              volutpat tortor elementum id. Donec eget rhoncus nisl, vitae
              eleifend leo.
            </p>
          </div>
          <div className="blog3">
            <div className="blog_card">
              <div className="card-img">
                <img src={blog3img} alt="" />
              </div>
              <div className="card-content">
                <div className="author_name">
                  <p>
                    {" "}
                    By <span>John Doe</span> l Aug 23, 2021{" "}
                  </p>
                </div>
                <h2>
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae
                </h2>
                <p>
                  Praesent tempor gravida magna, id accumsan risus gravida et.
                  Aliquam id volutpat nulla, vitae semper massa. Ut et eleifend
                  lectus, ac porttitor sapien. Praesent ac nisi eu arcu laoreet
                  interdum sit amet id massa. Maecenas malesuada enim et maximus
                  cursus. Donec eu diam at lectus consequat hendrerit. Duis ut
                  ornare eros. Etiam eleifend, erat eget sollicitudin laoreet,
                  libero magna convallis nulla, at semper ligula nibh eget
                  lacus. Pellentesque accumsan lorem neque, in luctus urna
                  tempor vitae.{" "}
                </p>
              </div>
            </div>

            <div className="blog3bot">
              <p>
                Nulla nec lectus ut quam tempor gravida et non mi. Pellentesque
                rutrum dolor lectus, ut scelerisque nisl dictum ac. Sed
                fringilla suscipit rutrum. Vivamus facilisis hendrerit feugiat.
                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
                posuere cubilia curae; Morbi ut diam elementum, aliquam augue
                sit amet, lacinia massa. Interdum et malesuada fames ac ante
                ipsum primis in faucibus. Pellentesque habitant morbi tristique
                senectus et netus et malesuada fames ac turpis egestas. Proin
                elementum facilisis ex ac semper. Aliquam dapibus magna eget
                tortor volutpat, in sodales neque lobortis. Phasellus odio
                magna, tincidunt vel nibh sit amet, gravida malesuada dui.
                Quisque malesuada rutrum feugiat.
              </p>
              <p>
                Mauris eget metus enim. Nam massa odio, euismod faucibus
                vestibulum at, dignissim a est. Ut malesuada est dolor, eu
                volutpat tortor elementum id. Donec eget rhoncus nisl, vitae
                eleifend leo.
              </p>
            </div>
          </div>
          <div className="blog3">
            <div className="blog_card_last">
              <div className="card-img">
                <img src={blog3img2} alt="" />
              </div>
              <div className="card-content">
                <div className="author_name">
                  <p>
                    {" "}
                    By <span>John Doe</span> l Aug 23, 2021{" "}
                  </p>
                </div>
                <h2>
                  Vestibulum ante ipsum primis in faucibus orci luctus et
                  ultrices posuere cubilia curae
                </h2>
                <p>
                  Praesent tempor gravida magna, id accumsan risus gravida et.
                  Aliquam id volutpat nulla, vitae semper massa. Ut et eleifend
                  lectus, ac porttitor sapien. Praesent ac nisi eu arcu laoreet
                  interdum sit amet id massa. Maecenas malesuada enim et maximus
                  cursus. Donec eu diam at lectus consequat hendrerit. Duis ut
                  ornare eros. Etiam eleifend, erat eget sollicitudin laoreet,
                  libero magna convallis nulla, at semper ligula nibh eget
                  lacus. Pellentesque accumsan lorem neque, in luctus urna
                  tempor vitae.{" "}
                </p>
              </div>
            </div>

            <div className="blog3bot">
              <p>
                Nulla nec lectus ut quam tempor gravida et non mi. Pellentesque
                rutrum dolor lectus, ut scelerisque nisl dictum ac. Sed
                fringilla suscipit rutrum. Vivamus facilisis hendrerit feugiat.
                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
                posuere cubilia curae; Morbi ut diam elementum, aliquam augue
                sit amet, lacinia massa. Interdum et malesuada fames ac ante
                ipsum primis in faucibus. Pellentesque habitant morbi tristique
                senectus et netus et malesuada fames ac turpis egestas. Proin
                elementum facilisis ex ac semper. Aliquam dapibus magna eget
                tortor volutpat, in sodales neque lobortis. Phasellus odio
                magna, tincidunt vel nibh sit amet, gravida malesuada dui.
                Quisque malesuada rutrum feugiat.
              </p>
              <p className=" pb-5">
                Mauris eget metus enim. Nam massa odio, euismod faucibus
                vestibulum at, dignissim a est. Ut malesuada est dolor, eu
                volutpat tortor elementum id. Donec eget rhoncus nisl, vitae
                eleifend leo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bloghero;
